import axios, { type AxiosInstance } from "axios";
import { useAuthStore } from "@/store/auth.store";
import env from "@/lib/env";
import { createTraceHeaders } from "@/lib/tracing";

const api: AxiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30_000,
});

// Attach token on every request
api.interceptors.request.use((config) => {
  Object.assign(config.headers, createTraceHeaders());
  const token = useAuthStore.getState().accessToken ?? env.devToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// No real refresh flow for now — clear auth on 401
api.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      useAuthStore.getState().clearAuth();
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        const currentPath = `${window.location.pathname}${window.location.search}`;
        window.location.assign(`/login?redirect=${encodeURIComponent(currentPath)}`);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
